import Vue from "vue";
import BibliotecaService from "../domain/corpore/BibliotecaService";
import SwalMessage from "../domain/message/SwalMessage";

function initialState() {
  return {
    contexto: {}
  };
}

const mutations = {
  updateContexto(state, contexto) {
    state.contexto = contexto;
  }
};

const actions = {
  async getContexto({ state, commit }, { login, tipo }) {
    const bibliotecaService = new BibliotecaService(Vue.http);
    commit("updateContexto", "");

    await bibliotecaService
      .getContexto(login, tipo)
      .then(({ contexto }) => commit("updateContexto", contexto))
      .catch(err => {
        console.log(err.message);
        SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
      });
  },
  setContexto({ commit }, contexto) {
    commit("updateContexto", contexto);
  }
};

const namespaced = true;

const biblioteca = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default biblioteca;



// WEBPACK FOOTER //
// ./src/store/biblioteca.js